export default __webpack_public_path__ + "static/media/livro7.44d37dc9.png";